calilily_Gateway = function(options) {
	this.settings = {
		url        : '',
		cookie     : 'chk-visit',
		cookieDays : 1,
		overlay    : ''
	};
	
	if (options) {
		$.extend(this.settings, options);
	};
};
calilily_Gateway.prototype = {
	init: function() {
		var gateway = this;
		if (!this.check()) {
			$(function() {
				gateway._showPopup();
			});
			return true;
		} else {
            gateway._hidePopup();
        }
		return false;
	},
	ok: function() {
		this.extendCookie();
		this._hidePopup();
	},
	extendCookie: function() {
		var date = new Date();
		date.setTime(date.getTime() + (this.settings.cookieDays * 86400000));
		var cookieValue = this.settings.cookie + "=true; expires="+ date.toGMTString() + "; path=/;";
		if (fpglobals.cookieDomain) {
			cookieValue += " domain=" + fpglobals.cookieDomain + ";";
		}
		document.cookie = cookieValue;
	},
	check: function() {
		if (document.cookie.length > 0) {
			var start, end;
			start = document.cookie.indexOf(this.settings.cookie + "=");
			if (start != -1) {
				start = start + this.settings.cookie.length+1;
				end = document.cookie.indexOf(";", start);
				if (end == -1) {
					end = document.cookie.length;
				}
				return unescape(document.cookie.substring(start, end));
			} 
		}
		return false;
	},
	_showPopup: function() {
		$.ajaxSetup({
			async: true
		});
		$.ajaxSetup({
			async: false
		});
		$('.age-gate-module').css({'display':'flex'});
		$('html').addClass('hidden');
	},
	_hidePopup: function() {
		$('.age-gate-module').fadeOut('fast', function() {
			$('.age-gate-module').remove();
		});
		$('html').removeClass('hidden');
	}
};